import { Uploads } from './Uploads';

export function Yield() {
  return <Uploads type="yield" />;
}
